/* global System */
// register component(s) with react habitat

export default { EventsArchive: () => System.import('./data-component') }
